import axiosInstance from "src/common/axiosInstance";

const botService = {
  types() {
    return axiosInstance.get("/whatsapp-bots/types");
  },

  aiDirectory() {
    return axiosInstance.get("/whatsapp-bots/ai-directory");
  },

  index(workspaceId) {
    return axiosInstance.get(
      `/whatsapp-bots/workspace/${workspaceId}`
    );
  },

  show(botId) {
    return axiosInstance.get(
      `/whatsapp-bots/${botId}`
    );
  },

  create(data) {
    return axiosInstance.post(
      "/whatsapp-bots",
      data
    );
  },

  update(botId, data) {
    return axiosInstance.put(
      `/whatsapp-bots/${botId}`,
      data
    );
  },

  toggleStatus(botId) {
    return axiosInstance.patch(
      `/whatsapp-bots/${botId}/toggle-status`
    );
  },

  destroy(botId) {
    return axiosInstance.delete(
      `/whatsapp-bots/${botId}`
    );
  },
};

export default botService;